import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import OverlayScrollbars from 'overlayscrollbars';
import { first } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { AssignmentDefinition, GroupDTO } from './cv-point-store-product-assignment-cxone.model';
import { PointStoreProductAssignmentService } from 'src/app/gamification/marketplace/admin/services/point-store-product-assignment.service';
import { CvPointStoreProductService } from '../../services/cv-point-store-product.service';
import { PointStoreProductEditService } from 'src/app/gamification/marketplace/admin/services/point-store-product-edit.service';
import { PointStoreProductEdit } from '../../models/point-store-product-edit.model';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-point-store-product-assignment-cxone',
    templateUrl: './cv-point-store-product-assignment-cxone.component.html',
    styleUrls: ['./cv-point-store-product-assignment-cxone.component.scss'],
    providers: [DialogService]
})
export class CvPointStoreProductAssignmentCxoneComponent implements OnInit {
    @Input() formDataBinding: FormGroup;
    @ViewChild('pointStoreProductAssignmentCxoneGrid') agGrid: AgGridAngular;

    pspes: PointStoreProductEdit = null;
    prodInfoOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            visibility: 'visible',
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "custom-scrollbar"
        },
        overflow: {
            x: 'hidden',
            y: 'scroll'
        },
    };

    public gridOptions: GridOptions = null;

    private assignModal: DynamicDialogRef;
    public assignmentsLabel: string = "";
    public assignmentsSearchPlaceholder: string = "";
    private selectedAssignment: AssignmentDefinition = null;

    public assignments: GroupDTO[] = [];

    constructor(
        private cvLocalizationFactory: CVLocalizationService,
        private agGridHelperService: AgGridHelperService,
        private dialogSrvc: DialogService,
        private cvPointStoreProductService: CvPointStoreProductService,
        private pointStoreProductAssignmentService: PointStoreProductAssignmentService,
        private pointStoreProductEditService: PointStoreProductEditService) {
        this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    }

    ngOnInit(): void {
        this.assignmentsSearchPlaceholder = this.getLocalizationString('Search', 'Search') + '...';
        this.assignmentsLabel = '0 ' + this.getLocalizationString('Groups', 'Groups').toLocaleLowerCase();
        this.createAssignment();
        setTimeout(() => {
            this.setupAgGrid();
        }, 2000);
    }


    public setupAgGrid(): void {
        this.gridOptions = {
            headerHeight: (this.assignments.length > 0) ? 44 : 0,
            suppressRowClickSelection: true,
            suppressCellFocus: true,
            rowSelection: 'multiple',
            suppressMovableColumns: true,
            suppressContextMenu: true,
            rowClass: 'product-assignment-row',
            rowHeight: 36,
            suppressLoadingOverlay: true,
            defaultColDef: {
                flex: 1,
                sortable: true,
                resizable: false,
                suppressMenu: true,
            },
            columnDefs: [
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Agent', 'Agent').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 2,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Company', 'Company').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 3,
                },
                {
                    colId: "GroupID",
                    field: "Email",
                    headerName: this.getLocalizationString('Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1,
                },
            ],
            overlayNoRowsTemplate: `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                  <svg class="cxoneFavoriteState mb-2">
                                      <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                  </svg>
                                  <p class="cxone-error-text">${this.getLocalizationString("No_Group_Assigned_Yet", "No group assigned yet")}</p>
                              </div>`,
            onGridReady: (params) => {
                params.api.setGridOption('rowData', []);
                params.api.setGridOption('rowData', this.assignments);
                params.api.sizeColumnsToFit(); 
                this.fillForm();
            },
            onRowDataUpdated: (event) => {
                this.assignGridMessage();
                this.updateAssignmentsLabel(event.api);
            },
            onFilterChanged: (event) => {
                this.assignGridMessage();
                this.updateAssignmentsLabel(event.api);
            },
            onColumnResized(event) {
                event.api.sizeColumnsToFit(); 
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            }
        };
    }

    private assignGridMessage(): void {
        if (this.assignments.length > 0 && this.agGrid?.api.getDisplayedRowCount() == 0) {
            this.updateNoRowsMessage();
        } else {
            this.updateNoAssignmentMessage();
        }
    }

    private updateNoRowsMessage(): void {
        this.gridOptions.overlayNoRowsTemplate = `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                                <svg class="cxoneFavoriteState mb-2">
                                                    <use href="../App_Themes/CXone/icons/no-results.svg#no-results"></use>
                                                </svg>
                                                <p class="cxoneEmptyText">${this.getLocalizationString('No_Result_Found', 'No result found')}</p>
                                            </div>`;
    }

    private updateNoAssignmentMessage(): void {
        this.gridOptions.overlayNoRowsTemplate = `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                                  <svg class="cxoneFavoriteState mb-2">
                                                      <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                                  </svg>
                                                  <p class="cxone-error-text">${this.getLocalizationString("No_Group_Assigned_Yet", "No group assigned yet")}</p>
                                              </div>`;
    }

    private updateAssignmentsLabel(api: GridApi): void {
        let assignmentLabel = "";
        let assignmentCount = api.getDisplayedRowCount();
        let singluar: boolean = assignmentCount == 1;
        switch (this.selectedAssignment.Level) {
            //agent
            case 1:
                assignmentLabel = singluar ? this.getLocalizationString('Agent', 'Agent').toLocaleLowerCase() : this.getLocalizationString('Agents', 'Agents').toLocaleLowerCase();
                break;
            //team
            case 2:
                assignmentLabel = singluar ? this.getLocalizationString('Team', 'Team').toLocaleLowerCase() : this.getLocalizationString('Teams', 'Teams').toLocaleLowerCase();
                break;
            //company
            case 3:
                assignmentLabel = singluar ? this.getLocalizationString('Company', 'Company').toLocaleLowerCase() : this.getLocalizationString('Companies', 'Companies').toLocaleLowerCase();
                break;
            default:
                assignmentLabel = this.getLocalizationString('Groups', 'Groups').toLocaleLowerCase();
        }
        if (assignmentLabel != "")
            this.assignmentsLabel = `${assignmentCount} ${assignmentLabel}`;
        else
            this.assignmentsLabel = assignmentLabel;

        if (api.getDisplayedRowCount() == 0) {
            this.assignmentsLabel = `${assignmentCount} ${this.getLocalizationString('Groups', 'Groups').toLocaleLowerCase()}`;
            api.showNoRowsOverlay();
        }
        else {
            api.hideOverlay();
        }
    }

    public createAssignment(): void {
        this.selectedAssignment = {
            AssignAll: false,
            Emp: [],
            Level: 0
        };
    }

    public onAssignmentsFilterChange(searchText): void {
        this.agGrid?.api.setGridOption('quickFilterText', searchText);
    }

    public removeSelectedAssignments(): void {
        if (!this.agGrid?.api) {
            return;
        }
        let selected: GroupDTO[] = [];
        this.agGrid?.api.getSelectedRows().forEach(e => {
            selected.push(e);
        });
        //Group Level, GroupId
        this.selectedAssignment.Emp = this.selectedAssignment.Emp.filter(f => {
            return !selected.some((s) => {
                return f.GroupLevel === s.GroupLevel && f.GroupID === s.GroupID;
            })
        });
        this.setupAssignments(false);
    }

    openAssignModal() {
        if (this.assignModal != null)
            return;

        let assigned: any = {
            emp: [],
            rec: [],
            agentAttribute: [],
            login: []
        };

        assigned["emp"] = this.selectedAssignment.Emp;

        let options: any = {
            modalTitle: this.getLocalizationString("Assign_Employee_Group", "Assign Employee Group"),
            modalSaveLabel: this.getLocalizationString("Assign", "Assign"),
            modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
            useBulkAdd: false,
            singleAdd: false,
            singleLevel: true,
            singleType: true,
            showTypeValues: { emp: true, rec: false, agent_att: false, logins: false },
            assignedEntities: assigned,
            maxEmpLevel: 2,
            singleAssignValidation: true, //this is used to show the validation message
            singleAssignMessage: this.getLocalizationString("Assign_Single_Group_Message", "A product can be assigned to either an agent or a team, but not both.")
        };

        this.assignModal = this.dialogSrvc.open(null as any, {
            width: "1198px",
            height: "720px",
            baseZIndex: 10000,
            data: {
                options: options
            },
            styleClass: 'cx-one-ui product-assignment-modal btn-bg-is-white'
        });

        this.assignModal.onClose.pipe(first()).subscribe(this.assignToolClosed.bind(this));

    }

    private assignToolClosed(dto: any): void {
        if (dto != null) {
            this.selectedAssignment.Emp.splice(0);
            this.assignments.splice(0);
            this.selectedAssignment.AssignAll = false;
            this.selectedAssignment.Emp = [...dto.selected["emp"], ...dto.assigned["emp"]];
            dto.assigned.emp.forEach(e => {
                this.selectedAssignment.Level = e.GroupLevel;
                if (this.selectedAssignment.Level === 1) {
                    e.Email = this.getTeamName(e.ParentGroupID);
                };
            });
            dto.selected.emp.forEach(e => {
                this.selectedAssignment.Level = e.GroupLevel;
                if (this.selectedAssignment.Level === 1) {
                    e.Email = this.getTeamName(e.ParentGroupID);
                };
            });
            this.setupAssignments(false);
        }
        this.assignModal = null;
    }

    private getTeamName(key: number) {
        const teams = this.cvPointStoreProductService.getTeams();
        const foundObject = teams.find(item => item.groupDTO.GroupID === key);
        return foundObject?.groupDTO?.GroupName;
    }

    /**
     * 
     * @param onfillFunction , if true the setupAssignments() will be used in the fillForm, else from the assignToolClosed() function.
     */
    private setupAssignments(onfillFunction: boolean): void {
        this.buildAssignments(onfillFunction);

        if (!!this.agGrid?.api) {
            this.agGrid?.api.setGridOption('headerHeight', (this.assignments.length > 0) ? 44 : 0);
            this.agGrid?.api.setGridOption('columnDefs', [
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Agent', 'Agent').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1,
                    headerCheckboxSelection: this.selectedAssignment.Level == 1,
                    checkboxSelection: this.selectedAssignment.Level == 1,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 2,
                    headerCheckboxSelection: this.selectedAssignment.Level == 2,
                    checkboxSelection: this.selectedAssignment.Level == 2,
                },
                {
                    colId: "GroupID",
                    field: "GroupName",
                    headerName: this.getLocalizationString('Company', 'Company').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 3,
                    headerCheckboxSelection: this.selectedAssignment.Level == 3,
                    checkboxSelection: this.selectedAssignment.Level == 3,
                },
                /* The above code defines an object for creating a "Team" column. The field property is set to
                   "Email" because we are reusing the original object retrieved from the selected agents, and we
                    store the team name in this "Email" property. */
                {
                    colId: "GroupID",
                    field: "Email",
                    headerName: this.getLocalizationString('Team', 'Team').toLocaleUpperCase(),
                    hide: this.selectedAssignment.Level != 1
                },
            ]);
            this.agGrid?.api.setGridOption('rowData', []);
            this.agGrid?.api.setGridOption('rowData', this.assignments);
            this.updateAssignmentsLabel(this.agGrid?.api);
        }
    }

    private buildAssignments(onfillFunction: boolean): void {
        this.assignments.splice(0);
        const obj = {
            empAssignAll: false,
            emp: [],
            rec: [],
            attr: [],
            coreAssignAtType: null,
            coreAssignAtLevel: 0
        };
        if (this.selectedAssignment.Emp.length > 0) {
            for (let listItem of this.selectedAssignment.Emp) {
                if (listItem.BaseGroupType == 0)
                    obj.emp.push(listItem);
                else if (listItem.BaseGroupType == 1)
                    obj.rec.push(listItem);
                // else if (listItem.AttributeValueID != null)
                //     obj.attr.push(listItem);
                //this code is used for attributes disabled at the moment.
            }
            if (obj.attr.length > 0) {
                obj.attr = [...new Map(obj.attr.map(item => [item['AttributeValueName'], item])).values()];
            }
        } else if (this.selectedAssignment.Emp.length <= 0) {
            //For now CXOne is not supporting unassigned products if that happen we should set to false this variable.
            obj.empAssignAll = true;
        } else {
            obj.empAssignAll = true;
        }
        if (!onfillFunction) {
            this.pointStoreProductAssignmentService.pspef.modifiedPointStoreProduct.PointStoreProductAllAssignments = cloneDeep(obj);
        }
        this.assignments = cloneDeep(this.selectedAssignment.Emp);

    }

    getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationFactory.getCachedText("MarketPlace_Management", key, defaultValue);
    }

    private fillForm(): void {

        if (this.pspes.modifiedPointStoreProduct.PointStoreProductID == 0 && !this.pspes.copiedProduct) {
            return;
        }

        let index: number = 0;
        for (const emp of this.pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp) {
            this.selectedAssignment.Emp.push(emp);
            this.selectedAssignment.Level = emp.GroupLevel;
            if (this.selectedAssignment.Level === 1) {
                this.selectedAssignment.Emp[index].Email = this.getTeamName(emp.ParentGroupID);
            };
            index++;
        }
        this.setupAssignments(true);
    }
}
